// src/pages/Nursing.js
import React from "react";

const Drivers = () => {
  return (
    <div className="text-center p-10">
      <h1 className="text-4xl font-bold text-green-500">Drivers</h1>
      <p className="text-gray-600 mt-4">We are a company committed to providing excellent service.</p>
    </div>
  );
};

export default Drivers;
